var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEarnestroiScBlockchainEtheriumBinance(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64.248,
    height: 64.465,
    viewBox: "0 0 64.248 64.465",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2",
    transform: "translate(1.057 1.073)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1",
    transform: "translate(0.7 0.71)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31665",
    "data-name": "Path 31665",
    d: "M82.645.71l7.524,7.7L71.224,27.36,63.7,19.836Z",
    transform: "translate(-52.279 -0.71)",
    fill: "none",
    stroke: "#0e8ece",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31666",
    "data-name": "Path 31666",
    d: "M94.067,63.71l7.524,7.7L71.224,101.782,63.7,94.258Z",
    transform: "translate(-52.279 -52.289)",
    fill: "none",
    stroke: "#012043",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31667",
    "data-name": "Path 31667",
    d: "M8.224,126.71l7.524,7.7-7.524,7.524L.7,134.415Z",
    transform: "translate(-0.7 -103.867)",
    fill: "none",
    stroke: "#0e8ece",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31668",
    "data-name": "Path 31668",
    d: "M157.067,126.71l7.524,7.7-30.367,30.367-7.524-7.524Z",
    transform: "translate(-103.857 -103.867)",
    fill: "none",
    stroke: "#012043",
    strokeWidth: 2.5
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEarnestroiScBlockchainEtheriumBinance);
export default __webpack_public_path__ + "static/media/earnestroi-sc-blockchain-etherium-binance.0e6965581ef9385145410d4ec59e3168.svg";
export { ForwardRef as ReactComponent };